import React, { FC } from 'react';
import { Radio } from 'antd';
import styles from './styles.module.css';
import * as translations from './strings';
import { getLangKey } from '../../models/Language';

const strings = translations[getLangKey()];

export type DetailsTabKey =
  | 'taskInfo'
  | 'attachments'
  | 'comments'
  | 'activity'
  | 'integrations';

const DEFAULT_TABS: DetailsTabKey[] = ['taskInfo', 'integrations'];

const TAB_LABELS: Record<DetailsTabKey, string> = {
  taskInfo: strings.taskInfo,
  attachments: strings.attachments,
  comments: strings.comments,
  activity: strings.activity,
  integrations: strings.integrations
};

type Props = {
  handleOnChange?: (isTaskInfo: boolean) => void;
  isTaskInfo?: boolean;
  tabs?: DetailsTabKey[];
  value?: DetailsTabKey;
  onChange?: (tab: DetailsTabKey) => void;
};

const DetailsTab: FC<Props> = ({
  handleOnChange,
  isTaskInfo = true,
  tabs = DEFAULT_TABS,
  value,
  onChange
}) => {
  const activeTab = value || (isTaskInfo ? 'taskInfo' : 'integrations');

  const handleTabChange = (tab: DetailsTabKey) => {
    if (onChange) {
      onChange(tab);
      return;
    }
    if (handleOnChange) handleOnChange(tab === 'taskInfo');
  };

  const getLabel = (tab: DetailsTabKey) => {
    if (tab !== 'integrations') return TAB_LABELS[tab];

    return (
      <span className={styles.integrationsLabel}>
        {TAB_LABELS.integrations}
      </span>
    );
  };

  return (
    <Radio.Group
      options={tabs.map(tab => ({
        label: getLabel(tab),
        value: tab
      }))}
      onChange={event => handleTabChange(event.target.value as DetailsTabKey)}
      value={activeTab}
      optionType="button"
      buttonStyle="solid"
      className={styles.detailsRadio}
    />
  );
};

export default DetailsTab;
